<shrd-pf-ui-meta-nav-item>
  <button
    shrdUicButton
    variant="tertiaryMinorBorderlessNeutralDark"
    class="my-0 meta-nav-item"
    shrdUicFlyout
    [ngbPopover]="popoverTemplate"
    placement="bottom"
    [autoPosFixedWidth]="true"
    [placeInStickyParent]="true"
    [showWhiteArrow]="true"
    (visibilityChange)="onVisibilityChange($event)"
    
  >
    <span
      [shrdPfUiMaxWidth]="buttonCustomMaxWidth"
      [update]="navItem"
      [ngClass]="buttonCustomMaxWidth ? 'btn-truncate-1' : 'no-truncate'"
    >
      {{ navItem.titleShort || navItem.title }}&#x200E;
    </span>
    <shrd-uic-svg-icon [icon]="navItem.icon"></shrd-uic-svg-icon>
  </button>
</shrd-pf-ui-meta-nav-item>

<ng-template #popoverTemplate>
  <shrd-uic-flyout-body
    class="d-none d-md-block p-0"
    [ngClass]="flyoutClass"
    [scrollbarEnabled]="false"
    [hasGrid]="false"
  >
    <ng-content></ng-content>
  </shrd-uic-flyout-body>
</ng-template>
